import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import { JSX } from "react";
import ConfirmationButton from "shared/components/ConfirmationButton";
import useStore from "zustand-store";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "utils/consts";

type PropsType = {
    icon?: JSX.Element;
    isOpen: boolean;
    title: string;
    description: string;
    actionTitle?: string;
    action?: () => void;
}

const GlobalDialog = (props: PropsType) => {
    const { icon, isOpen, action, title, description, actionTitle } = props;
    const hideGlobalDialog = useStore(state => state.hideGlobalDialog);

    return (
        <Dialog
            open={isOpen}
            onClose={hideGlobalDialog}
            fullWidth
            maxWidth="xs"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >

            <DialogTitle sx={{ p: 1, display: "flex", justifyContent: "flex-end" }}>
                <IconButton aria-label="close" onClick={hideGlobalDialog}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {icon && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        "& svg, & img": { width: "80px", height: "80px" }
                    }}
                >
                    {icon}
                </Box>
            )}

            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <DialogContentText
                        id="alert-dialog-title"
                        sx={{
                            textAlign: "center",
                            fontSize: "1.4rem",
                            fontWeight: 600,
                            color: colors.darkBlue
                        }}
                    >
                        {title}
                    </DialogContentText>
                </Box>

                <DialogContentText
                    id="alert-dialog-description"
                    sx={{
                        textAlign: "center",
                        color: colors.darkBlue
                    }}
                >
                    {description}
                </DialogContentText>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 5
                    }}
                >
                    <ConfirmationButton
                        onClick={() => {
                            hideGlobalDialog();
                            action && action();
                        }}
                        variant="contained"
                        sx={{
                            width: { xs: "80%", sm: "60%" }
                        }}
                    >
                        {actionTitle || "Fermer"}
                    </ConfirmationButton>
                </Box>
            </DialogContent>

        </Dialog>
    );
}

export default GlobalDialog;
